<template>
  <div class="member-footer footer" v-if="checkedOnOpenPage">
    <div
      v-if="isActivateCover && exportDisabled"
      class="submit button--primary disabled"
    >
      {{ actions[currAction] }}
    </div>
    <div
      v-else
      class="submit button--primary"
      @click="
        onClickBtn();
        reportSubmit(currAction);
      "
    >
      {{ actions[currAction] }}
    </div>
    <!-- {{`（共${UserMsg.transformRemains}次视频导出权益，剩余：${UserMsg.transformRemain}次）`}} -->
    <!-- <div class="free-user-tip" v-if="(isFreeUser || isSoloUser || isLevel2) && UserEquity.exportNum < Infinity">
      {{`（剩余：${UserMsg.transformRemain > 999 ? '999+' : UserMsg.transformRemain}次视频导出权益）`}}
    </div>-->
    <!-- <div class="footer__text" v-show="currAction === 'toVIP' || currAction === 'toSVIP' || currAction === 'toSSVIP'">
      您使用了（高级）VIP素材或功能，如后续需要导出还请升级会员。
    </div>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import analysis from "@/components/mixins/analysis/exportDialog";
import checkPersonVideo from "../../mixins/checkPersonVideo";

export default {
  props: {
    exportInfo: {
      type: Object,
      default() {
        return {
          limit: null,
          num: null,
        };
      },
    },
    checkedPixel: {
      type: Object,
      default() {
        return {};
      },
    },
    isActivateCover: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  mixins: [analysis, checkPersonVideo],
  data() {
    return {
      actions: {
        "dialog.exportNum": "确认导出",
        dialog: "确定",
        confirm: "确认导出",
        "confirm.again": "确认导出",
        toVIP: "升级会员 免费导出",
        toSVIP: "解锁VIP付费权益再导出", // '开通企业会员 免费导出',
        toSSVIP: "升级至尊版会员 免费导出",
      },
      levelMap: {
        toVIP: "1",
        toSVIP: "2",
        toSSVIP: "3",
      },
      currAction: "",
      checkedOnOpenPage: true,
      personVideosExcess: false,
    };
  },
  computed: {
    ...mapGetters([
      "UserMsg",
      "UserEquity",
      "UserLevel",
      "UserLevelType",
      "IsVipSprites",
      "isPersonVip",
    ]),
    ...mapGetters({
      coverForbiddenState: "CoverForbiddenState", // 自定义封面封禁
    }),
    isFreeUser() {
      return this.UserLevelType === 0 && this.UserLevel === 0;
    },
    isSoloUser() {
      return this.isPersonVip;
    },
    isLevel2() {
      return this.UserLevelType === 2;
    },
    exportDisabled() {
      const { state } = this.coverForbiddenState;
      return (state === 2 || state === 0);
    }
  },
  watch: {
    "IsVipSprites.type": {
      handler() {
        this.currAction = this.getAction();
      },
      immediate: true,
    },
    "IsVipSprites.dataLength": {
      handler() {
        this.currAction = this.getAction();
      },
      immediate: true,
    },
  },
  created() {
    this.$bus.on("app.checkedMaterialOnOpenPage", () => {
      this.checkedOnOpenPage = true;
    });
  },
  methods: {
    isPersonVideosExcess() {
      let filtered =
        this.IsVipSprites.data.filter((v) => v.type === "uploadVideoNUM") || [];
      return filtered.length > 0;
    },
    isRightsRisk() {
      let removed = this.IsVipSprites.data.filter((v) => v.removed) || [];
      let noFont = this.IsVipSprites.data.filter((v) => v.fileType != 15);
      return (
        removed.length ||
        this.hasPayFont() ||
        (this.UserMsg.payForMaterial != 1 &&
          (noFont.length || this.UserEquity.isEchart))
      );
    },
    getAction(flag) {
      // flag = flag === void 0 ? this.IsVipSprites.type : flag;
      let vipSpritesLength = this.IsVipSprites.dataLength || 0;
      this.personVideosExcess = this.isPersonVideosExcess();

      // let chartSprites = vipSprites.filter(item => item.type = 'Chart') || [];

      if (
        this.checkedPixel.value !== "480" &&
        this.UserEquity.exportNum < Infinity &&
        !this.UserMsg.transformRemain
      ) {
        return "dialog.exportNum";
      }
      // 可以导出
      if (!this.isRightsRisk() || !vipSpritesLength) {
        // if (this.isFreeUser || this.isLevel2) {
        //   return 'confirm.again';
        // }
        return "confirm";
      } else {
        // if (this.UserEquity.isEchart) {
        //   return 'toSVIP';
        // }
        // return this.isBasicCompany() ? 'toSVIP' : 'toVIP';
        return "toSVIP"; // vip 素材清单
      }

    },
    isBasicCompany() {
      switch (this.UserLevelType) {
        case 1:
          return true;
        default:
          return false;
      }
    },
    onClickBtn() {
      const vm = this;
      if (this.currAction === "confirm") {
        this.submit();
      } else if (this.currAction === "confirm.again") {
      } else if (this.currAction === "dialog.exportNum") {
        vm.isFreeUser &&
          vm.$modal.show("vipDialog", {
            msg: `您的${this.UserMsg.transformRemains}次视频导出权益已经使用完毕，升级个人VIP，可无限使用！`,
            target: "vipsolo",
            type: "solo",
          });

        this.isLevel2 &&
          this.$modal.show("vipDialog", {
            msg: "您的视频导出权益次数已使用完毕，请购买资源包或是升级企业至尊版可无限使用!",
            target: "vip",
            type: "vip.s",
            package: "pricing/vipsolo?source=1",
            secondaryBtnType: "package",
          });
      } else if (this.currAction === "dialog") {
        this.limit === 1 &&
          vm.$modal.show("vipDialog", {
            msg: "您本地上传的视频资源大于1个，升级个人VIP可扩充到3个。",
            target: "vipsolo",
            type: "solo",
            bottomLink: "/vip",
            bottomLinkText: "本地上传视频无限制，点击了解高级会员",
          });

        // this.limit === 3 && this.$bus.emit('FeaturesPop_vue', {
        //   name: 'vipEquity',
        //   msg: '您本地上传的视频资源大于3个，开通企业会员可无限使用。',
        //   btnMsg: '立即开通',
        //   type: 2,
        //   btnMsgLink: '/vip',
        //   baiduAction: '',
        //   levelType: 'vip'
        // });
        this.limit === 3 &&
          vm.$modal.show("vipDialog", {
            msg: "您本地上传的视频资源大于3个，开通企业会员可无限使用。",
            target: "vip",
            type: "vip",
          });
      } else {
        // this.buyMember()
        this.$bus.emit("Modal_vue", {
          name: "delVip",
          data: {
            type: "record",
          },
        });
      }
    },
    submit() {
      this.$emit("submit");
    },
    buyMember() {
      let link = document.createElement("a");
      let levelType = this.levelMap[this.currAction] || "1";
      link.href = `/vip`;
      link.target = "_blank";
      link.click();
      this.emitPaid();
    },
    emitPaid() {
      this.$bus.emit("FeaturesPop_vue", {
        name: "vipPayment",
        msg: "请在相应的付款页面进行操作",
        btnClose: "遇到问题",
        btnMsg: "付款成功",
        fs: "payPriceEvent_vue",
        msgType: 2,
        type: 2,
      });
    },
    hasPayFont() {
      let arr = this.IsVipSprites.data || [];
      return (
        arr.find((v) => v.type === "Text" || v.type === "RichText") &&
        this.UserMsg.payForFont !== 1
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/colors";
.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__text {
    margin-top: 12px;
    font-size: 12px;
  }
}
.submit {
  min-width: 160px;
  padding-right: 20px;
  padding-left: 20px;
  margin: auto;
  color: $c0;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  height: 40px;
  background-color: #5778fb;
  border-radius: 4px;
  &:hover {
    background-color: #7d95f5;
  }

  &.disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}
.free-user-tip {
  padding-top: 12px;
  color: #5778fb;
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/exportDialog/memberFooter.vue